








import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class VideoViewer extends Vue {
  @Prop() private src!: string;
}
